import { render, staticRenderFns } from "./SVGCopy.vue?vue&type=template&id=11c2caac&scoped=true&"
import script from "./SVGCopy.vue?vue&type=script&lang=js&"
export * from "./SVGCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2caac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c2caac')) {
      api.createRecord('11c2caac', component.options)
    } else {
      api.reload('11c2caac', component.options)
    }
    module.hot.accept("./SVGCopy.vue?vue&type=template&id=11c2caac&scoped=true&", function () {
      api.rerender('11c2caac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGCopy.vue"
export default component.exports